module.exports = __webpack_public_path__ + "static/media/app-04.0c2b892a.png";